import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import {
    ChooseAssetsToSellAssets,
    ChooseAssetsToSwitchAssets,
} from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { DrawdownIncomeReviewDetailsModel } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeReviewDetailsModel";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import {
    getSellableAssets,
    hasEnhancedPensionProtection,
    isCappedOrFlexIOrUFPLS,
    isRegualr,
    showChooseAssetstoSell,
    showSwitchInvestments,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { LessThanAge } from "../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { PensionBenefitsInstructionStore } from "../../../PensionBenefitsWizard/Store/Variable";
import { PensionBenefitsAction } from "../../../PensionBenefitsWizard/Actions/PensionBenefitsAction";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { IllHealth } from "../../../Common/SIPP/DrawdownDetails/IllHealth";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { PensionOptions } from "../../../Common/SIPP/DrawdownDetails/PensionOptions";
import { PreADayPensionDetails } from "../../../Common/SIPP/DrawdownDetails/PreADayPensionDetails";
import { PensionProtection } from "../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { ProtectionInformation } from "../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { InvestmentPathSelection } from "../../../Common/SIPP/DrawdownDetails/InvestmentPathSelection";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { DrawdownTypeOption } from "../../../Common/SIPP/DrawdownDetails/DrawdownType";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { IncomeReview } from "../../../Common/SIPP/DrawdownDetails/IncomeReview";
import { addYears } from "../../../../../../../react-core/utils/date";
import { Information } from "../../../Common/SIPP/DrawdownDetails/Information";
import { RegularCrystallisation } from "../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { CrystallisationDetailsSection } from "../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { LTABreakdownDetails } from "../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { TaxFreeLumpSumPayment } from "../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DIAC } from "../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { DrawdownPriceLock } from "../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { CalculateEstimatedPaye } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/CalculateEstimatedPaye";
import IncomeBankDetails from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { WhatIfAction } from "../../Action/WhatIfAction";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IsRestrictedToPensionContributionWarningText, drawdownDetailsMessage } from "../../../Common/Resource/Contents";
import { SecurityType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { PensionEstimatedPayQuery } from "../../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPayQuery";
import { PensionIncomeConfiguration } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionIncomeConfiguration";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { AllowanceDetails } from "../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IPensionBenefitsDetailsProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel;
    hasCashIsa?: boolean;
    customerId?: number;
}

interface IPensionBenefitsDetailsState {
    assets: ChooseAssetsToSellAssets[];
    assetsToSwitchTable: ChooseAssetsToSwitchAssets[];
    isLoading: boolean;
    originType: DrawdownType;
    incomeReviewDetails: DrawdownIncomeReviewDetailsModel;
    minimumDate_DisinvestNeed?: Date;
    minimumDate_DisinvestNoNeed?: Date;
    isDisinvest: Boolean;
    TailoreddrawdownPermittable: boolean;
}

export class PensionBenefitsDetails extends ProcessComponent<
    IPensionBenefitsDetailsProps,
    IPensionBenefitsDetailsState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
            assetsToSwitchTable: [],
            isLoading: false,
            originType: null,
            incomeReviewDetails: null,
            isDisinvest: true,
            TailoreddrawdownPermittable: false
        };
    }

    isValid() {
        if (this.props.data?.Contribution?.DrawdownModel?.PreADay) {
            this.props.showErrorMsgPopUp(["Cancel the process unless select 'No' for Pre-A-Day pension details"]);
        }
        if (!this.props.data?.Contribution?.DrawdownModel?.InstructionId) {
            this.props.showErrorMsgPopUp(["Cancel the process unless as the client does not have ill health"]);
            return false;
        }
        if (this.state.originType == DrawdownType.Flexible) {
            this.updateDrawdownIncomeReviewDetails();
        }
        var isRestrictedProtection = false;
        if (this.props.data?.Contribution?.HasPensionProtection && this.props.data?.Contribution?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.Contribution?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        if (this.state.TailoreddrawdownPermittable == false && this.state.originType == DrawdownType.Regular) {
            return false
        }
        return (
            super.isValid() && this.props.data?.Contribution?.DrawdownModel?.PreADay == false && !isRestrictedProtection
        );
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    private getComponentProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) => {
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                );
            },
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: getQueryParameters()["subaccounthierarchyid"],
        };
    };

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(this.props.type, hierarchyId, subAccountHierarchyId, (data) => {
                this.setState({ assets: data.assetsToSell });
                this.setState({ assetsToSwitchTable: data.assetsToSwitch });
            });
        });
    };

    private updatePensionCommencementLumpSumAllocations() {
        const { data } = this.props;
        const drawdownModel = data?.Contribution?.DrawdownModel;
        if (!drawdownModel) return;

        if (drawdownModel.DrawdownType == DrawdownType.Regular)
        {
            if (drawdownModel.IsAcrossAllAssets == null || drawdownModel.IsAcrossAllAssets == true)
            {
                const changes = { PensionCommencementLumpSumAllocations: [] };
                this.onDataChange(
                    (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "Contribution"),
                    changes,
                    this.props.data.Contribution,
                    "DrawdownModel"
                );   
            }
            return;
        }

        if (drawdownModel.PensionOption == PensionOption.UFPLS)
        {
            if ((drawdownModel.IsAcrossAllAssets == null || drawdownModel.IsAcrossAllAssets == true) && drawdownModel.CrystallisationDetails.CrystallisationAmount.Amount > drawdownModel.CrystallisationDetails.AvailableCash.Amount)
            {
                const changes = { PensionCommencementLumpSumAllocations: [] };
                this.onDataChange(
                    (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "Contribution"),
                    changes,
                    this.props.data.Contribution,
                    "DrawdownModel"
                );
                return;
            }
        }
            
        
        const availableCash = drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount || 0;
        const pclsAmount = drawdownModel?.TaxFreeLumpSum?.Amount || 0;
        
        if (!this.state.assets || this.state.assets.length === 0) return;
        
        const cashAsset = this.state.assets.find(a => a.Assets.toUpperCase() === "GBP CASH");
        if (!cashAsset) return;
        
        let changes = {};
        if (availableCash >= pclsAmount) {
            const pclsAllocations = [{
                ProductId: cashAsset.Id,
                Name: cashAsset.Assets,
                Percentage: 100,
                Type: cashAsset.ProductType
            }];
            changes = { PensionCommencementLumpSumAllocations: pclsAllocations };
        } else {
            changes = {
                IsAcrossAllAssets: true,
                PensionCommencementLumpSumAllocations: []
            };
        }
        
        this.onDataChange(
            (changeData) => this.onDataChange(this.props.onChange, changeData, this.props.data, "Contribution"),
            changes,
            this.props.data.Contribution,
            "DrawdownModel"
        );
    }

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();
        const { data, customerId } = this.props;
        if (customerId && customerId > 0) {
            const subAccountAmendmendInstructionId = getQueryParameters()["id"];
            const instructionId = data?.Contribution?.DrawdownModel?.InstructionId ?? 0;
            if (instructionId == 0) {
                WhatIfAction.CreateDrawdownInstruction(subAccountAmendmendInstructionId, customerId);
            }
        }

        if (!this.props.data.Contribution?.AdviceGiven) {
            this.onDataChange(this.props.onChange, { AdviceGiven: true }, this.props.data, "Contribution");
        }
        if (
            !this.ageNeedIllHealth(this.props.data) &&
            !this.props.data?.Contribution?.DrawdownModel?.InstructionId
        ) {
            this.createAndLoadDrawdownInstruction(this.props.data);
        }

        this.setMinimumDateDisinvestState();
        this.setInitialOriginType(this.props.data.Contribution?.DrawdownModel?.DrawdownType);
        if (data.Contribution?.DrawdownModel?.DrawdownType == DrawdownType.Flexible) {
            this.getDrawdownIncomeReviewDetails();
        }

        const params = getQueryParameters();
        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            0,
            (data: ClientTradableInvestments) => {
                const result = data.CurrentIndividualHoldings.filter(
                    (ele) =>
                        (ele.CurrQuantity > 0 && ele.MarketValue?.Amount > 0) &&
                        ele.SecurityType == SecurityType.OffPlatform).every(ele => ele.Permittailoreddrawdown == true);
                this.setState({ TailoreddrawdownPermittable: result });
            })
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);

        if (
            this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets != undefined &&
            prevProps.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets !=
            this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets
        ) {
            this.setIsDisinvest();
        }
        if (
            prevProps?.data?.Contribution?.DrawdownModel?.DrawdownType &&
            (prevProps?.data?.Contribution?.DrawdownModel?.DrawdownType !=
            this.props.data?.Contribution?.DrawdownModel?.DrawdownType)
        ) 
        {
            this.doCalculation();
        }

        if (
            prevProps.data?.Contribution?.DrawdownModel?.TaxFreeLumpSum?.Amount !==
            this.props.data?.Contribution?.DrawdownModel?.TaxFreeLumpSum?.Amount
        )
        {
            this.updatePensionCommencementLumpSumAllocations();
        }
    }

    componentWillUpdate(nextProps, nextState): void {
        super.componentWillUpdate(nextProps, nextState);

        //assetsTable state change
        if (isNullOrEmpty(this.state.assets) && !isNullOrEmpty(nextState.assets)) {
            this.setIsDisinvest(nextState.assets);
        }
    }

    setInitialOriginType(type: DrawdownType) {
        if (type) {
            this.setState({ originType: type });
        }
    }

    setMinimumDateDisinvestState() {
        DrawdownCalculationAction.getMinimumPaymentDate(
            getQueryParameters()["subaccounthierarchyid"],
            true,
            true,
            (result) => {
                this.setState({
                    minimumDate_DisinvestNeed: new Date(result.MinimumDateTime),
                });
            }
        );

        DrawdownCalculationAction.getMinimumPaymentDate(
            getQueryParameters()["subaccounthierarchyid"],
            false,
            false,
            (result) => {
                this.setState({
                    minimumDate_DisinvestNoNeed: new Date(result.MinimumDateTime),
                });
            }
        );
    }

    private setIsDisinvest(assetsTable: ChooseAssetsToSellAssets[] = []) {
        let assetData = !isNullOrEmpty(this.state.assets) ? this.state.assets : assetsTable;
        let assetAllocations = this.props.data?.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations;
        let isAcrossAllAssets = this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets ?? true;

        //if the asset allocation got 100% cash, then disinvestment is not needed
        if (
            (isAcrossAllAssets && assetData && assetData.length == 1) ||
            (!isAcrossAllAssets &&
                assetAllocations &&
                assetData &&
                assetData.some(
                    (x) =>
                        x.Assets.toUpperCase() == "GBP CASH" &&
                        assetAllocations.some((y) => y.ProductId == x.Id && y.Percentage == 100)
                ))
        ) {
            this.setState({
                isDisinvest: false,
            });
            return;
        }

        this.setState({
            isDisinvest: true,
        });
    }

    private getCurProductType(): SubAccountType {
        const clientInfo = ClientAccountStore.getClientAccountInfo();
        const params = getQueryParameters();
        const productType = (clientInfo.SubAccounts || []).find(
            (ele) => ele.HierarchyId == params["subaccounthierarchyid"]
        )?.SubAccountType;
        return productType;
    }

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const originType =
            this.state.originType ||
            PensionBenefitsInstructionStore.getData()?.Contribution?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.Contribution?.DrawdownModel?.DrawdownType;
        let _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.Contribution.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        WhatIfAction.saveInstruction(1, _data, this.getCurProductType(), this.props.customerId, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data: PensionContributionModel) {
        return (
            this.ageNeedIllHealth(data) &&
            !data?.Contribution?.DrawdownModel?.InstructionId
        );
    }

    private ageNeedIllHealth(data: PensionContributionModel) {
        return data?.Contribution?.PensionProtection?.PensionSchemeSpecificProtection?.ProtectedRetirementAge
            ? false
            : LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
    }

    private getDrawdownIncomeReviewDetails() {
        const account = ClientAccountStore.getActiveClientSubAccounts();
        const hierarchyId = account.find((x) => x.SubAccountType == SubAccountType.Npr).HierarchyId;
        if (account) {
            PensionBenefitsAction.getDrawdownIncomeReviewDetails(hierarchyId, (val) => {
                this.setState({
                    incomeReviewDetails: val,
                });
            });
        }
    }

    private updateDrawdownIncomeReviewDetails() {
        const model = this.state.incomeReviewDetails;
        if (model?.DrawdownIncomeReviewDetails) {
            PensionBenefitsAction.updateDrawdownIncomeReviewDetails(model);
        }
    }

    private createAndLoadDrawdownInstruction(data: PensionContributionModel, isIllHealth: boolean = false) {
        this.setState({ isLoading: true });
        DrawdownCalculationAction.postDrawdown(
            this.props.data?.Contribution?.HierarchyId,
            null,
            (drawdownModel: DrawdownModel) => {
                const hierarchyId = getQueryParameters()["hierarchyid"];
                const account = ClientAccountStore.getClientAccountInfo();
                const subAccountHierarchyId = account.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr)
                    .HierarchyId;
                const type = Number(getQueryParameters()["type"]);

                PensionBenefitsAction.getInstruction(
                    data?.Contribution?.HierarchyId,
                    type,
                    hierarchyId,
                    subAccountHierarchyId,
                    this.props.customerId,
                    () => {
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });

                        if (drawdownModel?.DrawdownType == DrawdownType.Flexible) {
                            this.getDrawdownIncomeReviewDetails();
                        }
                    }
                );
            },
            isIllHealth,
            true,
        );
    }

    private onChangeDrawdownType(v: any) {
        if (v.DrawdownType == DrawdownType.Flexible) {
            this.getDrawdownIncomeReviewDetails();
        }

        this.setState({
            originType: this.props.data.Contribution?.DrawdownModel?.DrawdownType,
        });

        this.onDataChange(
            (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
            { DrawdownType: v.DrawdownType },
            this.props.data.Contribution,
            "DrawdownModel"
        );
    }

    private getCalculateEstimatedPayeQueries():Array<PensionEstimatedPayQuery> {
        return [
            {
                HierarchyId: getQueryParameters()["subaccounthierarchyid"],
                PensionIncomeConfiguration: PensionIncomeConfiguration.PensionLevel,
                GrossAmount: this.props.data.Contribution.DrawdownModel.CrystallisationDetails.CrystallisationAmount,
                Frequency: Frequency.Monthly,
                PaymentDate: JsonDateParser.toJsonDate(new Date())
            }];
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const { originType, incomeReviewDetails } = this.state;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.createAndLoadDrawdownInstruction(data, true);
                    }}
                />
            );
        }
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <h2>Pension Benefits Details (Pre-retirement Arrangement)</h2>
                <>
                    {this.state.TailoreddrawdownPermittable == false && originType == DrawdownType.Regular && (
                        <Alert alertType={AlertType.Error} message={drawdownDetailsMessage.HasTailoredDrawdownErrorMessage} />
                    )}
                    <PensionOptions
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.Contribution?.PensionProtection}
                        clientDetail={data?.ClientDetails}
                        validateDrawdown={(d) =>
                            this.onDataChange(onChange, { DrawdownModel: d }, data, "Contribution")
                        }
                        subaccountHierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                        instructionOwnerHierarchyId={data?.Contribution?.HierarchyId}
                    />
                    <PreADayPensionDetails {...this.getComponentProps(data, onChange)} />
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            <PensionProtection
                                {...this.props}
                                onRef={(ref) => this.appendChild(ref)}
                                data={data?.Contribution}
                                onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                process={ProcessType.WhatIf}
                                doCalculation={() => this.doCalculation()}
                            />
                            <ProtectionInformation
                                {...this.getComponentProps(data, onChange)}
                                process={ProcessType.WhatIf}
                                pensionProtection={data?.Contribution?.PensionProtection}
                            />

                            {data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                <InvestmentPathSelection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers}
                                    activityType={data?.ActivityType}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            { InvestmentPathwayAnswers: v },
                                            data.Contribution,
                                            "DrawdownModel"
                                        );
                                    }}
                                />
                            )}

                            <hr />

                            {data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                <DrawdownTypeOption
                                    isImmediateTaxFreeLumpSum={
                                        !CommonHelper.isNullOrEmpty(
                                            data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId
                                        )
                                    }
                                    originType={
                                        this.state.originType ||
                                        PensionBenefitsInstructionStore.getData()?.Contribution?.DrawdownModel
                                            ?.DrawdownType
                                    }
                                    {...this.getComponentProps(data, onChange)}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                    activityType={data?.ActivityType}
                                    onChange={(v) => {
                                        this.onChangeDrawdownType(v);
                                    }}
                                    PersonalRecommendation={
                                        data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers
                                            ?.PersonalRecommendation
                                    }
                                />
                            )}
                        </>
                    )}
                    {originType == DrawdownType.Flexible && data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <IncomeReview
                            data={
                                this.props.data?.Contribution == null
                                    ? {
                                        DrawdownIncomeReviewDetails: {
                                            IncomeReviewDate: addYears(new Date(), 1),
                                            IncomeReviewFrequency: 12,
                                        },
                                    }
                                    : this.props.data?.Contribution
                            }
                            onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                            onRef={(ref) => this.appendChild(ref)}
                        />
                    )}
                   
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            {isRegualr(data?.Contribution?.DrawdownModel) &&
                                data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                    <RegularCrystallisation
                                        doCalculation={() => this.doCalculation()}
                                        {...this.getComponentProps(data, onChange)}
                                        process={ProcessType.WhatIf}
                                        hierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                                        minimumDate={
                                            this.state.isDisinvest
                                                ? this.state.minimumDate_DisinvestNeed
                                                : this.state.minimumDate_DisinvestNoNeed
                                        }
                                    />
                                )}
                            {isCappedOrFlexIOrUFPLS(data?.Contribution?.DrawdownModel) && (
                                <CrystallisationDetailsSection
                                    isImmediateTaxFreeLumpSum={
                                        !CommonHelper.isNullOrEmpty(
                                            data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId
                                        )
                                    }
                                    cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                                    doCalculation={() => this.doCalculation()}
                                    modelData={null}
                                    processType={ProcessType.WhatIf}
                                    {...this.getComponentProps(data, onChange)}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                />
                            )}
                            {(data?.Contribution?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.Contribution?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                !hasPrimaryProtection(data?.Contribution?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.Contribution?.PensionProtection) && (
                                    <>
                                        <LTABreakdownDetails
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.WhatIf}
                                            lessThan75={ageLessThan75}
                                            hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                        />
                                    </>
                                )}
                            <AllowanceDetails
                                doCalculation={() => this.doCalculation()}
                                {...this.getComponentProps(data, onChange)}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                process={ProcessType.WhatIf}
                            />
                            <TaxFreeLumpSumPayment
                                doCalculation={this.doCalculation}
                                process={ProcessType.WhatIf}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                {...this.getComponentProps(data, onChange)}
                                lessThan75={ageLessThan75}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                            />
                            {data?.Contribution?.DrawdownModel?.DrawdownType !== DrawdownType.Regular &&
                                data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                    <DIAC
                                        {...this.getComponentProps(data, onChange)}
                                        modelData={data?.Contribution}
                                        existingAccount={true}
                                    />
                                )}
                            <OAC
                                readonly={true}
                                type={SubAccountType.Npr}
                                onChange={(v) => { }}
                                data={{
                                    OngoingAdviceCharge:
                                        data?.Contribution?.DrawdownModel?.DrawdownAdviserCharge?.OngoingAdviserCharge,
                                }}
                                onRef={(ref) => this.appendChild(ref)}
                            />
                            <ChargesOnIllustration {...this.getProps("Contribution")} />
                            <hr />
                            <DrawdownPriceLock {...this.getComponentProps(data, onChange)} />
                            {showChooseAssetstoSell(
                                data?.Contribution?.DrawdownModel,
                                ChooseAssetsToSellFor.Drawdown,
                                true
                            ) && (
                                    <>
                                        <ChooseAssetsToSell
                                            {...this.getComponentProps(data, onChange)}
                                            tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                            assets={this.state.assets}
                                        />
                                        {data?.Contribution?.DrawdownModel?.IsAcrossAllAssets == false && (
                                            <ChooseAssetsToSellTable
                                                data={
                                                    data?.Contribution?.DrawdownModel
                                                        ?.PensionCommencementLumpSumAllocations || []
                                                }
                                                tableData={this.state.assets}
                                                modelData={data?.Contribution?.DrawdownModel}
                                                onRef={(ref) => this.appendChild(ref)}
                                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                                onChange={(v) => {
                                                    this.onDataChange(
                                                        (changes) =>
                                                            this.onDataChange(onChange, changes, data, "Contribution"),
                                                        { PensionCommencementLumpSumAllocations: v },
                                                        data.Contribution,
                                                        "DrawdownModel"
                                                    );
                                                    this.setIsDisinvest();
                                                }}
                                                processType={ProcessType.WhatIf}
                                                reason={ChooseAssetsToSellFor.Drawdown}
                                                isAcrossAllAssets={data?.Contribution?.DrawdownModel?.IsAcrossAllAssets}
                                            />
                                        )}
                                    </>
                                )}

                            {data?.Contribution?.DrawdownModel?.PensionOption === PensionOption.UFPLS && (
                                <>
                                    <CalculateEstimatedPaye query={this.getCalculateEstimatedPayeQueries()} />
                                    <hr />
                                    <IncomeBankDetails
                                        data={data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations || []}
                                        onChange={(value) => {
                                            onChange(
                                                setValueByKey(
                                                    data,
                                                    "Contribution.DrawdownModel.Income.IncomePaymentAllocations",
                                                    value
                                                )
                                            );
                                        }}
                                        showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                                        onRef={(ref) => this.appendChild(ref)}
                                        allBankAccounts={data?.AllBankAccounts}
                                        showPropotionOfIncome={false}
                                    />
                                </>
                            )}
                        </>
                    )}
                </>
            </PartLoading>
        );
    }
}
